import * as React from 'react';

import FilePresentation32 from './FilePresentation32';

export const filePresentation32 = () => <FilePresentation32 />;

export default {
    title: 'Icon/Content/FilePresentation32',
    component: FilePresentation32,
    parameters: {
        notes: "`import FilePresentation32 from 'box-ui-elements/es/icon/content/FilePresentation32';`",
    },
};
